const border = {
   colors: {
      standard: '#A9A9A9',
      inverted: '#FFFFFF'
   }
};

export default border;



// WEBPACK FOOTER //
// ./src/UI/themes/borders/index.js